import Decimal from 'decimal.js';

export function formatDecimal(decimal: Decimal): string {
    if (!decimal || !Decimal.isDecimal(decimal)) {
        return '';
    }
    const fixed = decimal.toFixed();
    const splitNumber = fixed.split('.');
    // format the first part, keep the last one and then stitch it back together
    // regex taken from https://stackoverflow.com/a/2901298
    const formattedFirstPart = splitNumber[0].replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ','
    );
    if (splitNumber.length > 1) {
        return `${formattedFirstPart}.${splitNumber[1]}`;
    }
    return formattedFirstPart;
}
